import { makeAutoObservable } from 'mobx';
import type { SmtpFieldsStore } from 'areas/administration/authentication/smtp/components/smtp-fields/smtpFieldsStore';

export const SMTP_TYPE = 'SMTP';

export enum SmtpSecurityProtocol {
	None = 'NONE',
	StartTls = 'STARTTLS',
	Tls = 'TLS',
}

export const smtpDefaultPorts: Record<SmtpSecurityProtocol, number> = {
	[SmtpSecurityProtocol.None]: 25,
	[SmtpSecurityProtocol.StartTls]: 587,
	[SmtpSecurityProtocol.Tls]: 465,
};

export class SmtpAuthentication {
	securityProtocol = SmtpSecurityProtocol.None;
	host = '';
	port: number = smtpDefaultPorts[SmtpSecurityProtocol.None];
	username = '';
	password = '';
	hasPassword = false;
	clearPassword = false;

	constructor(record?: Partial<SmtpAuthentication>) {
		makeAutoObservable(this);

		if (record) {
			this.securityProtocol = record.securityProtocol ?? SmtpSecurityProtocol.None;
			this.host = record.host ?? '';
			this.port = record.port ?? smtpDefaultPorts[this.securityProtocol];
			this.username = record.username ?? '';
			this.hasPassword = !!record.hasPassword;
		}
	}
}

export type SmtpFieldsProps = {
	store: SmtpFieldsStore;
};
